export default "__VITE_ASSET__D6jSitB9__"